export const TopMsg = (msg) => {
  return <label style={{ fontSize: 14 }}>{msg}</label>
}
